export const getCellNameLlaveCopa = (phrase, indexMatch, indexTeam) => {
  switch (phrase) {
    case "quarterLeft":
      if (indexMatch == 0 && indexTeam == 0)
        return "A1";
      else if(indexMatch == 0 && indexTeam == 1)
        return "B1"
      else if(indexMatch == 1 && indexTeam == 0)
        return "C1"
      else if(indexMatch == 1 && indexTeam == 1)
        return "D1"
    case "champion":
        return "CAMPEÓN";
    case "semiFinalLeft":
      if(indexTeam == 0)
        return "Semi C1"
      if(indexTeam == 1)
        return "Semi C2"
    case "final":
      if(indexTeam == 0)
        return "Final 1"
      if(indexTeam == 1)
        return "Final 2"
    case "semiFinalRight":
      if(indexTeam == 0)
        return "Semi C3"
      if(indexTeam == 1)
        return "Semi C4"
    case "quarterRight":
      if (indexMatch == 0 && indexTeam == 0)
        return "A2";
      else if(indexMatch == 0 && indexTeam == 1)
        return "B2"
      else if(indexMatch == 1 && indexTeam == 0)
        return "C2"
      else if(indexMatch == 1 && indexTeam == 1)
        return "D2"
    case "thirdPosition":
      if(indexTeam == 0)
        return "PS 1"
      if(indexTeam == 1)
        return "PS 2"
    default:
      return "aa";
  }
}


export const getSortedFixtures = (stage, fixtureData) => {
  return fixtureData?.filter(item => item.matchInfo.stage?.name === stage).sort((a, b) => {
    const idA = a.matchInfo.nextMatchWinnerId;
    const idB = b.matchInfo.nextMatchWinnerId;
    if (idA < idB) return -1;
    if (idA > idB) return 1;
    return 0;
  });
}

// ---------------------------------------------------------------------------
// Armado del cuadro de eliminación (Mundial FIFA 2026)
//
// La estructura real del cuadro está 100% en `nextMatchWinnerId` (cada partido
// apunta al partido al que avanza su ganador). El orden vertical de las
// tarjetas, en cambio, sigue la plantilla fija de la FIFA y NO se puede derivar
// ordenando por fecha ni por número ascendente: hay que mapearlo por el número
// oficial de partido. Ese número solo aparece embebido en las `phrase`
// ("Winner Match 74"), así que lo reconstruimos:
//   - 8vos / 4tos / semis: por orden cronológico (89-96, 97-100, 101-102)
//   - 16avos (73-88): por el par fijo del 8vo que alimentan; dentro del par, el
//     partido más temprano es el número más bajo (verificado contra el cuadro
//     oficial 2026).
// ---------------------------------------------------------------------------

const KO_STAGE_ORDER = ["16th Finals", "8th Finals", "Quarter-finals", "Semi-finals"];

// Plantilla oficial del Mundial 2026: orden de tarjetas (arriba -> abajo) por
// ronda y por lado, expresado en números de partido FIFA.
const KO_TEMPLATE = {
  left: {
    "16th Finals": [74, 77, 73, 75, 84, 83, 82, 81],
    "8th Finals": [90, 89, 93, 94],
    "Quarter-finals": [97, 98],
    "Semi-finals": [101],
  },
  right: {
    "16th Finals": [76, 78, 79, 80, 88, 86, 85, 87],
    "8th Finals": [91, 92, 95, 96],
    "Quarter-finals": [99, 100],
    "Semi-finals": [102],
  },
};

// 8vo (número FIFA) -> par de 16avos que lo alimentan (también plantilla fija).
// Lo usamos en vez de leer las phrase "Winner Match N", que desaparecen apenas
// se juega el partido y dejarían las tarjetas de 16avos sin número/posición.
const KO_EIGHTH_FEEDERS = {
  89: [73, 75], 90: [74, 77], 91: [76, 78], 92: [79, 80],
  93: [83, 84], 94: [81, 82], 95: [86, 88], 96: [85, 87],
};

const matchDateValue = (match) => {
  const date = match?.matchInfo?.date || "";
  const time = match?.matchInfo?.time || "";
  return Date.parse(`${date.replace("Z", "")}T${time.replace("Z", "")}`) || 0;
};

// Solo aplica para el Mundial 2026 (la plantilla y la numeración 73-104 son
// específicas de ese cuadro de 32 equipos). Para cualquier otra competencia
// devuelve null y el llamador usa su armado genérico previo.
export const isWorldCupBracket = (matches) =>
  matches?.some((m) => m?.matchInfo?.competition?.id === "70excpe1synn9kadnbppahdn7");

export const buildKnockoutBracket = (matches) => {
  if (!matches?.length || !isWorldCupBracket(matches)) return null;

  const childrenOf = (id) => matches.filter((m) => m.matchInfo?.nextMatchWinnerId === id);
  const byStage = (stage) => matches.filter((m) => m.matchInfo?.stage?.name === stage);

  // 1) Número oficial de cada partido
  const num = new Map();
  const rankByDate = (arr, base) =>
    arr
      .slice()
      .sort((a, b) => matchDateValue(a) - matchDateValue(b))
      .forEach((m, i) => num.set(m.matchInfo.id, base + i));

  rankByDate(byStage("8th Finals"), 89);
  rankByDate(byStage("Quarter-finals"), 97);
  rankByDate(byStage("Semi-finals"), 101);

  const finalMatch = byStage("Final")[0] || null;
  if (finalMatch) num.set(finalMatch.matchInfo.id, 104);
  const thirdPlace = byStage("3rd Place Final")[0] || null;
  if (thirdPlace) num.set(thirdPlace.matchInfo.id, 103);

  // 16avos: el 8vo que alimentan (por nextMatchWinnerId) define el par de
  // números; dentro del par, el partido más temprano es el número más bajo.
  byStage("8th Finals").forEach((parent) => {
    const pair = KO_EIGHTH_FEEDERS[num.get(parent.matchInfo.id)];
    if (!pair) return;
    const kids = childrenOf(parent.matchInfo.id).sort((a, b) => matchDateValue(a) - matchDateValue(b));
    if (kids[0]) num.set(kids[0].matchInfo.id, Math.min(...pair));
    if (kids[1]) num.set(kids[1].matchInfo.id, Math.max(...pair));
  });

  // 2) Colocar cada partido en su slot según la plantilla
  const numToMatch = new Map();
  matches.forEach((m) => {
    const n = num.get(m.matchInfo.id);
    if (n != null) numToMatch.set(n, m);
  });

  const rounds = {};
  KO_STAGE_ORDER.forEach((stage) => {
    rounds[stage] = {
      left: (KO_TEMPLATE.left[stage] || []).map((n) => numToMatch.get(n)).filter(Boolean),
      right: (KO_TEMPLATE.right[stage] || []).map((n) => numToMatch.get(n)).filter(Boolean),
    };
  });

  return { rounds, finalMatch, thirdPlace, matchNumber: num, stageOrder: KO_STAGE_ORDER };
};

export const sortFixturesByContestantOrder = (mode, stage1, stage2, fixtureData, matchesReference) => {

  const stage1fixture = fixtureData.filter(item => item.matchInfo.stage.name == stage1)
  const stage2fixture = fixtureData.filter(item => item.matchInfo.stage.name == stage2);
  const contestantOrder = matchesReference?.length > 0 ? matchesReference.flatMap(item => item.matchInfo.contestant.map(c => c.id)) : stage2fixture;

  if(mode == "straight"){
    function customSort(a, b) {
      const positionA = contestantOrder.indexOf(a.matchInfo.contestant[0].id);
      const positionB = contestantOrder.indexOf(b.matchInfo.contestant[0].id);
      return positionA - positionB;
    }

    return stage1fixture.sort(customSort);
  }else if(mode ==  "inverse"){
    const stage1fixture = fixtureData.filter(item => item.matchInfo.stage.name == stage1)

    const orderMap = new Map();
    contestantOrder.forEach((id, index) => orderMap.set(id, index));

    return stage1fixture.sort((a, b) => {
      const posA1 = orderMap.has(a.matchInfo.contestant[0].id) ? orderMap.get(a.matchInfo.contestant[0].id) : Infinity;
      const posA2 = orderMap.has(a.matchInfo.contestant[1].id) ? orderMap.get(a.matchInfo.contestant[1].id) : Infinity;
      const posB1 = orderMap.has(b.matchInfo.contestant[0].id) ? orderMap.get(b.matchInfo.contestant[0].id) : Infinity;
      const posB2 = orderMap.has(b.matchInfo.contestant[1].id) ? orderMap.get(b.matchInfo.contestant[1].id) : Infinity;

      const minPosA = Math.min(posA1, posA2);
      const minPosB = Math.min(posB1, posB2);

      return minPosA - minPosB;
    });
  }
  return [];
}

export const getScore = (position) => {
    const etScore = scores?.et?.[position] || 0;
    const ftScore = scores?.ft?.[position] || 0;
    const penScore = scores?.pen?.[position] ? `(${scores?.pen?.[position]})` : '';
    return matchStatus == "Fixture" ? "-" : `${etScore || ftScore} ${penScore}`;
}